import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const vehicleRoutes = {
    GET_VEHICLE_TYPES: "dashboard/core/vehicle/list/type",
}
export default {
    getlistByCompany(companyId) {
        return new Promise(resolve => {
            let newData = [];
            http.get(vehicleRoutes.GET_VEHICLE_TYPES, {params: companyId})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron tipos de vehiculo de esta compañia");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los tipos de vehiculo");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    getListGeneral() {
        return new Promise(resolve => {
            let newData = {};
            http.get(vehicleRoutes.GET_VEHICLE_TYPES)
                .then(({data}) => {
                    if (data.code < 0) {
                        toast.error(data.message);
                        newData = data;
                        return;
                    }
                    if (data.code === 0) {
                        toast.info(data.message);
                        newData = data;
                        return;
                    }
                    newData = data;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
}